<template>
  <header class="header">
    <div
      :class="['wrapper is-auth-wrapper', { menuVisible: $parent.menuVisible }]"
      v-if="authenticated"
    >
      <div class="left">
        <router-link to="/" class="logo">
          <img class="img" src="../images/logo.svg" />
          <div class="title tiny">Elystr</div>
        </router-link>
      </div>
      <div class="right">
        <router-link
          :to="
            '/rooms/' +
            $parent.activeTopic[0].room.slug +
            '/' +
            $parent.activeTopic[0].slug +
            '/chat'
          "
          v-if="$parent.activeTopic && $parent.activeTopic.length && $parent.activeTopic[0].slug && $parent.activeTopic[0].room.slug"
          class="button bordered-white active-chat-button"
        >
          <div class="dot"></div>
          {{ $t("Active chat") }}
        </router-link>
        <div class="nav">
          <router-link to="/" class="desc small nav-link">
            <b>{{ $t("Home") }}</b>
          </router-link>
          <router-link to="/rooms" class="desc small nav-link">
            <b>{{ $t("Rooms") }}</b>
          </router-link>
        </div>
        <router-link :to="{ name: 'Profile' }" class="button bordered-white">
          <img class="img" src="../images/user.svg" />
          <span>{{ $t("Profile") }}</span>
        </router-link>
      </div>
    </div>
    <div class="wrapper" v-else>
      <div class="left">
        <router-link to="/" class="logo">
          <img class="img" src="../images/logo.svg" />
          <div class="title tiny">Elystr</div>
        </router-link>
      </div>
      <div class="right">
        <router-link :to="{ name: 'Login' }" class="button">{{
          $t("Sign In")
        }}</router-link>
        <router-link :to="{ name: 'Register' }" class="button colored">{{
          $t("Sign UP")
        }}</router-link>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Header",
  props: [],
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    ...mapGetters("user", ["authenticated"]),
  },
};
</script>
